import { render, staticRenderFns } from "./ProfileAwards.vue?vue&type=template&id=d430d152&scoped=true&"
import script from "./ProfileAwards.vue?vue&type=script&lang=js&"
export * from "./ProfileAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d430d152",
  null
  
)

export default component.exports